import React, { Suspense, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ErrorBoundary } from 'react-error-boundary';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import { StoreProvider } from './contexts/storeContext';
import store from './stores';
import CentredSpinner from './components/CentredSpinner';
import AxiosConfig from './utils/AxiosConfig';
import ErrorPage from './components/ErrorPage';
import { generateRoutes, routesComponents } from './routes/routesHelper';
import { loadThemes } from './utils/themeUtils';
import localStorageWorker from './utils/localStorageWorker';
import useTheme from './hooks/useTheme';
import { ThemeStoreProvider } from './contexts/themeContext';

const App = (): JSX.Element | null => {
    // @ts-ignore
    momentDurationFormatSetup(moment);
    loadThemes().then((allThemes) =>
        localStorageWorker.setToLS('all-themes', allThemes),
    );
    const [theme, setMode] = useTheme();

    const fullScreenRoutes = useMemo(() => {
        const filteredRoutes = routesComponents.filter(
            (route) => route.fullScreen,
        );
        return filteredRoutes;
    }, []);

    return (
        <ThemeStoreProvider theme={theme} setTheme={setMode}>
            <ThemeProvider theme={theme}>
                <ErrorBoundary FallbackComponent={ErrorPage}>
                    <StoreProvider store={store}>
                        <ToastContainer style={{ fontSize: '1.2rem' }} />
                        <AxiosConfig />
                        <Router>
                            <Suspense fallback={<CentredSpinner />}>
                                <Switch>
                                    {generateRoutes(fullScreenRoutes)}
                                    <Redirect to="/login" />
                                </Switch>
                            </Suspense>
                        </Router>
                    </StoreProvider>
                </ErrorBoundary>
            </ThemeProvider>
        </ThemeStoreProvider>
    );
};

export default App;
